import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => localStorage.getItem("admin_token") || "";
export const setAdminToken = (t) => localStorage.setItem("admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("admin_token");

export const adminHeaders = () => ({
  headers: { Authorization: `Bearer ${getAdminToken()}` },
});

export const PROPERTY_NAMES = {
  hotel_due_pini: "Hotel Due Pini Conte",
  ga_conte: "G&A Conte B&B",
};
